import ChainIcon from '@passkeys/ui/chain-icon';

import { cn } from '@/ui/utils/classnames';

export interface FramedChainIconProps {
  name: string;
  displayName: string;
  className?: string;
}

function FramedChainIcon({
  name,
  displayName,
  className,
}: FramedChainIconProps) {
  return (
    <div
      className={cn(
        'h-[40px] w-[40px] rounded-xl bg-gray-100 p-[4px] theme-dark:bg-neutral-700',
        className,
      )}
    >
      <ChainIcon name={name} displayName={displayName} size={32} colored />
    </div>
  );
}

export default FramedChainIcon;
